'use client';

import { c as _c } from "react/compiler-runtime";
import type { PrV2FileStoryCommentPreview } from '@/app/pr-v2/[owner]/[repo]/pull/[number]/components/diff/pr-v2-file-story-metadata-utils';
import { PR_V2_TOOLTIP_TEXT_CLASSNAME } from '@/app/pr-v2/[owner]/[repo]/pull/[number]/components/shared/pr-v2-tooltip-styles';
const MAX_VISIBLE_COMMENT_PREVIEWS = 5;
type PrV2FileStoryIssuesTooltipContentProps = {
  commentPreviews: PrV2FileStoryCommentPreview[];
};
export function PrV2FileStoryIssuesTooltipContent(t0) {
  const $ = _c(14);
  const {
    commentPreviews
  } = t0;
  let hiddenCommentCount;
  let t1;
  let t2;
  let t3;
  if ($[0] !== commentPreviews) {
    const visibleCommentPreviews = commentPreviews.slice(0, MAX_VISIBLE_COMMENT_PREVIEWS);
    hiddenCommentCount = commentPreviews.length - visibleCommentPreviews.length;
    t3 = "max-h-80 max-w-[22rem] overflow-y-auto";
    t1 = "space-y-2";
    t2 = visibleCommentPreviews.map(_temp);
    $[0] = commentPreviews;
    $[1] = hiddenCommentCount;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    hiddenCommentCount = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hiddenCommentCount) {
    t4 = hiddenCommentCount > 0 ? <p className="border-t border-zinc-800/80 pt-2 text-xs text-zinc-400">{`and ${hiddenCommentCount} more`}</p> : null;
    $[5] = hiddenCommentCount;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(commentPreview) {
  return <div key={commentPreview.commentId} className="space-y-0.5 border-t border-zinc-800/80 pt-2 first:border-t-0 first:pt-0"><p className={PR_V2_TOOLTIP_TEXT_CLASSNAME}><strong className="font-semibold text-zinc-100">{commentPreview.author}</strong>{": "}{commentPreview.preview}</p></div>;
}